export default __webpack_public_path__ + "static/media/pic10.f7e5c633.jpg";